.searchSuggestionsContainer {
  background-color: var(--colors-grays-white);
  inset: 0;
  max-height: 100%;
  overflow: auto;
  position: fixed;
  top: 100%;
  transition:
    top 0.5s ease,
    opacity 0.5s ease;
  width: 100%;
  z-index: var(--z-search-suggestions);
}

.searchSuggestionsContainer::-webkit-scrollbar {
  display: none;
}

.emptyQuery {
  display: block;
}

.mobileSearchHeader {
  display: flex;
  flex-direction: column;
}

.mobileSearchHeading {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  width: 100%;
  position: sticky;
}

.dismissIcon {
  padding-top: 8px;
  padding-left: 8px;
  flex: 0 0 auto;
}

.searchText {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.searchFieldBox {
  padding-left: 16px;
  padding-right: 16px;
}

.searchFieldBox svg > path {
  fill: var(--colors-text-main);
}

.searchFieldBox input:placeholder-shown {
  text-overflow: ellipsis;
}

.productsList--loading {
  padding-bottom: 32px;
}

.searchQuery {
  padding: 20px 24px;
  display: block;
  color: var(--colors-text-main);
}

.searchQuery__mark {
  font-weight: var(--font-weight-semibold);
  background-color: transparent;
}

.waveyLoading {
  position: relative;
  margin-top: 8px;
  bottom: 0px;
  left: 0;
  right: 0;
}

/**
 * Non-standard pattern - introducing "tablet" width (768-1076).
 * Uses the full-screen search container up through 1076px.
 */
@media all and (width > 1076px) {
  .searchSuggestionsContainer {
    border-radius: 24px;
    box-shadow:
      0px 2px 16px 0px rgb(0 0 0 / 5%),
      0px 0px 0px 1px rgb(0 0 0 / 5%);
    inset: 0 auto auto 0;
    margin-top: var(--header-height);
    max-height: 664px;
    position: absolute;
    width: 360px;
  }

  .emptyQuery {
    display: none;
  }

  .mobileSearchHeader {
    display: none;
  }
}
